import { ref, onMounted, onBeforeUnmount } from 'vue'

export function useScreenCaptureGuard() {
  const isObscured = ref(false)

  function handleKeyDown(e: KeyboardEvent) {
    if (e.key === 'PrintScreen') {
      e.preventDefault()
      e.stopImmediatePropagation()
      return
    }

    const modKey = e.ctrlKey || e.metaKey
    if (modKey && e.key.toLowerCase() === 'p') {
      e.preventDefault()
      e.stopImmediatePropagation()
      return
    }

    if (modKey && e.shiftKey && e.key.toLowerCase() === 's') {
      e.preventDefault()
      e.stopImmediatePropagation()
    }
  }

  function handleVisibilityChange() {
    isObscured.value = document.visibilityState === 'hidden'
  }

  function handleWindowBlur() {
    isObscured.value = true
  }

  function handleWindowFocus() {
    isObscured.value = false
  }

  function protectCanvas(canvas: HTMLCanvasElement) {
    canvas.toDataURL = () => ''
    canvas.toBlob = (cb: BlobCallback) => {
      cb(null)
    }
  }

  onMounted(() => {
    window.addEventListener('keydown', handleKeyDown, { capture: true })
    document.addEventListener('visibilitychange', handleVisibilityChange)
    window.addEventListener('blur', handleWindowBlur)
    window.addEventListener('focus', handleWindowFocus)
  })

  onBeforeUnmount(() => {
    window.removeEventListener('keydown', handleKeyDown, { capture: true })
    document.removeEventListener('visibilitychange', handleVisibilityChange)
    window.removeEventListener('blur', handleWindowBlur)
    window.removeEventListener('focus', handleWindowFocus)
  })

  return { isObscured, protectCanvas }
}
